import { createSelector } from '@reduxjs/toolkit';
import { getProfileState } from './getProfileState';

export const getFtsProfile = createSelector(getProfileState, (state) => state?.ftsProfile);
